import {LocationInterface} from "@/shared/interfaces/LocationInterface";
import axios from "axios";
import {ConfigurationInterface} from "@/MarketSearch/interfaces/ConfigurationInterface";

export class LocationService {
    async findOne(identifier: string): Promise<LocationInterface | null> {
        try {
            const response = await axios
                .get(`/.rest/personalized/v1/locations/${identifier}`, {
                    headers: {
                        'Cache-Control': 'max-age=60',
                    }
                });
            return response.data;
        } catch (e) {
            return null
        }

    }

    async fetchAll(): Promise<ConfigurationInterface> {
        try {
            const response = await axios
                .get(`/.rest/personalized/v1/locations`,{
                    headers: {
                        'Cache-Control': 'max-age=60',
                    }
                });

            return {
                features: new Set(response.data.features),
                filter: new Set(response.data.filter),
                locations: new Set(response.data.locations)
            };
        } catch (e) {
            return {
                features: new Set(),
                filter: new Set(),
                locations: new Set(),
            };
        }
    }

    static hasWebsite(location: LocationInterface) {
        const link = document.createElement('a');
        link.href = location.website || '#';

        return (link.hostname !== window.location.hostname && link.hostname !== 'edeka-foodservice.de') || link.pathname !== '/';
    }

    static isExternal(location: LocationInterface) {
        const link = document.createElement('a');
        link.href = location.website || '#';

        return link.hostname !== window.location.hostname
    }
}
